import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Claim } from 'models/ClaimModel';


const ClaimList: React.FC = () => {
  const width = { date: 12, sno:12, count:10, submitby: 20, status:46  };
  const [formId, formName] = [Code.Form.Id.CLAIM, Code.Form.Name.CLAIM];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [claimData, setClaimData] = useState<Claim[]>([]); 
  const [selectedClaim, setselectedClaim] = useState<Claim | null>(null);
  const triggers = [pno, pageRows, search, activeId];
  const Privilege = Hooks.Privilege.List(formId);
  const locationId = Utility.Storage.LocationId();

  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Claim.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Claim.Id, 
        Name.Claim.Date,
        Name.Claim.Number,
        Name.Claim.Count,
        Name.Common.StatusName,
        Name.User.FirstName
      ]),
      ...(!Privilege.ALLLOC && { location_id: locationId }),
    });
     
    await API.Data.List<Claim>(url, setClaimData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Status} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, claimData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Date, width.date],
                [Title.FileNo, width.sno],
                [Title.Count, width.count, Code.Align.CENTER],
                [Title.Submitby, width.submitby],
                [Title.State, width.status],
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(claimData) && (
              <Control.Grid.Row>
                {claimData.map((claimData) => { return (
                <Control.Grid.Data<Claim> key={claimData.claim_id} itemKey={claimData.claim_key} data={claimData} setMenuPosition={setMenuPosition} setSelectedData={setselectedClaim} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={claimData.claim_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, claimData.claim_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Items values={[
                    [Utility.Format.DateOnly(claimData.claim_date), width.date], 
                    [claimData.claim_number, width.sno], 
                    [claimData.claim_count, width.count, Code.Align.CENTER], 
                    [claimData.user_first_name, width.submitby], 
                    [claimData.status_name, width.status], 
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={claimData.claim_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={claimData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedClaim?.claim_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedClaim?.claim_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default ClaimList;